var map = {
	"./AI智能体-0.svg": "69d2",
	"./AI智能体-1.svg": "593f",
	"./dashboard.svg": "f782",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./password.svg": "2a3d",
	"./sysadmin.svg": "049e",
	"./table.svg": "47f1",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./userList.svg": "4367",
	"./业务管理.svg": "babb",
	"./中控设备.svg": "2135",
	"./产品型号.svg": "5455",
	"./产品设备.svg": "d9ba",
	"./入库.svg": "05f4",
	"./出入库.svg": "df94",
	"./出入库明细.svg": "fd06",
	"./出库.svg": "7729",
	"./协议仓库.svg": "fdc4",
	"./地址簿.svg": "eb9b",
	"./安全管控-0.svg": "bcb0",
	"./安全管控-1.svg": "3c17",
	"./客户需求.svg": "e11c",
	"./广告管理.svg": "2ff0",
	"./库存.svg": "5e27",
	"./库存管理.svg": "0ee2",
	"./应用中心.svg": "4118",
	"./房间.svg": "708a",
	"./手机验证码.svg": "6bea",
	"./报表.svg": "0153",
	"./操作日志.svg": "941a",
	"./数智通讯管理-0.svg": "2bb2",
	"./数智通讯管理-1.svg": "992d",
	"./日志.svg": "a338",
	"./明细.svg": "13e4",
	"./智能设备.svg": "0ce8",
	"./权限管理.svg": "f44e",
	"./楼层.svg": "784b",
	"./楼栋.svg": "5c0b",
	"./汇总.svg": "8cb7",
	"./清单.svg": "c744",
	"./用户管理.svg": "00b7",
	"./租户管理.svg": "1c19",
	"./管理.svg": "7a4e",
	"./系统对接-0.svg": "7501",
	"./系统对接-1.svg": "81fc",
	"./系统管理-0.svg": "09fa",
	"./系统管理-1.svg": "e799",
	"./系统管理.svg": "9ae9",
	"./角色管理.svg": "4d63",
	"./设备.svg": "6f62",
	"./设备管理.svg": "82b2",
	"./设备账号.svg": "8d65",
	"./运营.svg": "8188",
	"./运营分析.svg": "f7c9",
	"./运营管理-0.svg": "ef20",
	"./运营管理-1.svg": "3f09",
	"./通讯录.svg": "8de6",
	"./通讯管理.svg": "70da",
	"./酒店管理-0.svg": "6693",
	"./酒店管理-1.svg": "45ef",
	"./酒店管理.svg": "3925",
	"./酒店管理菜单.svg": "0bfbd",
	"./风控审计.svg": "7075",
	"./首页.svg": "cba3",
	"./首页仪表盘-0.svg": "2ff5",
	"./首页仪表盘-1.svg": "c7b1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";